module.exports = __webpack_public_path__ + "img/model_40_zh.f6dcd327.jpg";